import React, { useState, useEffect } from "react";

import {
  SlOption,
  SlSelect,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router";
import api from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { formatSpentValue, languageOptions } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const year = yesterday.getFullYear();
const month = String(yesterday.getMonth() + 1).padStart(2, "0"); // Months are zero-based
const day = String(yesterday.getDate()).padStart(2, "0");

const formattedDate = `${year}-${month}-${day}`;
function AdResponses() {
  const [dateFilter, setDateFilter] = useState(formattedDate);
  const [initialRender, setInitialRender] = useState(true);
  const [lang_id, setLang_id] = useState("1");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getdata = async () => {
    setLoader(true);
    try {
      let res = await api({
        url: "/adresponses/data",
        method: "POST",
        responseType: "json",
        data: {
          lang_id,
          date: dateFilter,
        },
      });
      if (res.code === 200) {
        setData(res?.data);
      } else {
        if (res.data.code === 400)
          Toast("error", `Please Select Date On or Below ${formattedDate} `);
        else Toast("error", res.message);
        setData([]);
      }
      setLoader(false);
      setInitialRender(false);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    getdata();
  }, []);
  useEffect(() => {
    if (!initialRender) getdata();
  }, [lang_id, dateFilter]);

  return (
    <div className="inventory">
      <div className="flex items-center gap-3 mt-1 sticky top-0 z-10 w-full">
        <aside className="filters">
          <SlSelect
            placeholder="Select Language"
            name="lang"
            size="medium"
            onSlChange={(e) => {
              setLang_id(e.target.value);
            }}
            value={lang_id}
          >
            <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
            {languageOptions.map((item) => {
              return (
                <SlOption key={item.value} value={item.value}>
                  {item.label}
                </SlOption>
              );
            })}
          </SlSelect>
          <SlInput
            size="medium"
            type="date"
            placeholder="Date"
            onSlInput={(e) => {
              setDateFilter(e.target.value);
            }}
            value={dateFilter}
            max={formattedDate} // Restrict to today
          />
        </aside>
      </div>

      <div className="inv-table">
      <table
  className="table table-bordered table-impress"
  style={{ width: "100%", margin: "auto" }}
>
  <thead>
    <tr>
      <th>Position</th>
      <th>Adcode</th>
      <th>Requests</th>
      <th>Response</th>
      <th>Total Error</th>
      <th>Display</th>
      <th>No Fill</th>
      <th>Other errors</th>
    </tr>
  </thead>

  {Object.keys(data)?.length && !loader ? (
    <tbody>
      {Object.keys(data).map((key) => {
        const records = data[key]; // array
        return records.map((item, index) => (
          <tr key={`${key}-${index}`}>
            <th>{item.ad_position}</th>
            <td>{item.ad_code}</td>
            <td title={item.request_count}>{formatSpentValue(item.request_count)}</td>
            <td title={item.response_count}>{formatSpentValue(item.response_count)}</td>
            <td title={item.error_count}>{formatSpentValue(item.error_count)}</td>
            <td title={item.display_count}>{formatSpentValue(item.display_count)}</td>
            <td title={item.no_fill_count}>{formatSpentValue(item.no_fill_count)}</td>
            <td title={item.other_error_count}>{formatSpentValue(item.other_error_count)}</td>
          </tr>
        ));
      })}

      {
        (() => {
          const allItems = Object.values(data).flat(); // Flatten array of arrays

          const totals = allItems.reduce(
            (acc, item) => {
              acc.request_count += Number(item.request_count) || 0;
              acc.response_count += Number(item.response_count) || 0;
              acc.display_count += Number(item.display_count) || 0;
              acc.error_count += Number(item.error_count) || 0;
              acc.no_fill_count += Number(item.no_fill_count) || 0;
              acc.other_error_count += Number(item.other_error_count) || 0;
              return acc;
            },
            {
              request_count: 0,
              response_count: 0,
              display_count: 0,
              error_count: 0,
              no_fill_count: 0,
              other_error_count: 0
            }
          );

          return (
            <tr className="totals font-semibold bg-gray-100">
              <td colSpan={2}>Totals</td>
              <td title={totals.request_count}>{formatSpentValue(totals.request_count)}</td>
              <td title={totals.response_count}>{formatSpentValue(totals.response_count)}</td>
              <td title={totals.error_count}>{formatSpentValue(totals.error_count)}</td>
              <td title={totals.display_count}>{formatSpentValue(totals.display_count)}</td>
              <td title={totals.no_fill_count}>{formatSpentValue(totals.no_fill_count)}</td>
              <td title={totals.other_error_count}>{formatSpentValue(totals.other_error_count)}</td>
            </tr>
          );
        })()
      }
    </tbody>
  ) : !Object.keys(data).length && !loader ? (
    <NoDataFound colspan={8} />
  ) : (
    <TableLoader colspan={8} />
  )}
</table>

      </div>
    </div>
  );
}

export default AdResponses;
